function NegativeAmountFilter() {
  'ngInject';
  return function (input) {
    let amount = input;
    if(input && input != "") {
      amount = Number(Math.abs(Number(input))).toFixed(2);
      if(input.includes('-')){
        amount = '(' + amount + ')';
      }
    }
    return amount;
  };
}
export default {
  name: 'NegativeAmountFilter',
  fn: NegativeAmountFilter
};
